import { useResource } from '@landsbankinn/l16n';
import styled from '@emotion/styled';
import {
  Avatar,
  BottomButtons,
  Box,
  Button,
  Col,
  Flex,
  ListItem,
  RichButton,
  Span,
  TrashIcon24,
  UnorderedList,
} from '@landsbankinn/ui-kit';
import { type AppHubUser } from 'src/services/AppHubService';
import { res } from './AppLoginUsers.res';
const OpacityTrash = styled(TrashIcon24)`
  opacity: 0.5;

  button:hover & {
    opacity: 1;
  }
`;
type AppLoginUserButtonProps = {
  user: AppHubUser;
  onAuthenticateUser: (user: AppHubUser) => void;
  onRevokeUser: (user: AppHubUser) => void;
};
function AppLoginUserButton({
  user,
  onAuthenticateUser,
  onRevokeUser,
}: AppLoginUserButtonProps) {
  return (
    <Box paddingTop="1" position="relative" minHeight="90" width="100%">
      <RichButton
        instrumentAs="select_known_user"
        actionButtonAriaLabel="Delete user"
        actionButtonIcon={<OpacityTrash color="blue font" />}
        onClickActionButton={() => onRevokeUser(user)}
        borderBottom="transparent"
        condense
        onClick={() => onAuthenticateUser(user)}
        label={
          <Flex direction="row" crossAxisAlignment="start" width="100%">
            <Avatar
              size="32"
              accountType={user.type === 'retail' ? 'personal' : 'corporate'}
            />
            <Flex
              paddingLeft="12"
              direction="col"
              crossAxisAlignment="start"
              width="100%"
              colGap="7"
            >
              <Box>
                <Span fontVariant="h4" fontWeight="medium">
                  {user.name}
                </Span>
              </Box>

              <Box>
                <Span fontVariant="label" letterSpacing=".25">
                  {user.userName}
                </Span>
              </Box>
            </Flex>
          </Flex>
        }
      />
    </Box>
  );
}
type AppLoginUsersProps = {
  isMobile?: boolean;
  users: AppHubUser[];
  onAuthenticateUser: (user: AppHubUser) => void;
  onRevokeUser: (user: AppHubUser) => void;
  onQR: () => void;
};
export function AppLoginUsers({
  isMobile,
  users,
  onAuthenticateUser,
  onRevokeUser,
  onQR,
}: AppLoginUsersProps) {
  const { r } = useResource();

  return (
    <Col minHeight="429" paddingTop="28">
      <UnorderedList
        grow={!isMobile ? '1' : '0'}
        marginBottom={isMobile ? '64' : undefined}
      >
        {users.map((user) => (
          <ListItem
            key={user.userName}
            mainAxisAlignment="space between"
            crossAxisAlignment="center"
            direction="row"
          >
            <AppLoginUserButton
              user={user}
              onRevokeUser={onRevokeUser}
              onAuthenticateUser={onAuthenticateUser}
            />
          </ListItem>
        ))}
      </UnorderedList>
      <BottomButtons
        paddingBottom="0"
        paddingLeft="0"
        paddingRight="0"
        maxWidth="100%"
        grow="0"
      >
        <Button
          instrumentAs="select_another_user"
          variant="primary"
          width="100%"
          onClick={onQR}
        >
          {r(res.loginOtherUser)}
        </Button>
      </BottomButtons>
    </Col>
  );
}
